import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfiguratorCertificateComponent } from './configurator-certificate.component';
import {CertificatesModule} from '../../../components/certificates/certificates.module';



@NgModule({
  declarations: [ConfiguratorCertificateComponent],
    imports: [
        CommonModule,
        CertificatesModule
    ]
})
export class ConfiguratorCertificateModule { }
